import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac9d5bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dashboard-Card--background" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--1" })
], -1))
const _hoisted_2 = { class: "Dashboard-Card--inner" }
const _hoisted_3 = { class: "Dashboard-Card-text" }
const _hoisted_4 = { class: "Dashboard-Card-text__header" }
const _hoisted_5 = { class: "Dashboard-Card-text__content" }
const _hoisted_6 = { class: "cta color--2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cta__bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cta__bg--inner" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Dashboard-Card", [
      `theme--${_ctx.course ? _ctx.course.theme : _ctx.theme}`
    ]])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "title", {}, undefined, true),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _renderSlot(_ctx.$slots, "cta", {}, undefined, true)
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "image", {}, undefined, true)
    ])
  ], 2))
}